import type ExtendedPropertyUri from 'owa-service/lib/contract/ExtendedPropertyUri';
import { getExtendedPropertyUri } from 'owa-service/lib/ServiceRequestUtils';

/** Extended property that holds the value for Virtual Appointment (events created by VA 1p meeting template) */
export const VirtualAppointmentExtendedProperty: ExtendedPropertyUri = getExtendedPropertyUri(
    '00020329-0000-0000-C000-000000000046',
    'VirtualAppointment',
    'String'
);
